import '../../App.css'
import { FaSignInAlt } from "react-icons/fa";
import { IoSearch } from "react-icons/io5";
import { FaSearchPlus } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { useEffect, useRef, useState } from 'react';
import { Modal } from 'antd';
import { FaUser } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom'
import { IoMdArrowDropdown } from "react-icons/io";
import OpenBets from '../openbets';
import Appconfig from '../../config/config'
import axios from 'axios';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { useSelector, useDispatch } from 'react-redux';
import { getAllBets, emptyOpenBets } from '../../redux/slice/openBet/openBetSlice';
import { emptyUserInfo } from '../../redux/slice/userInfo/userInfoSlice';
import OpenRules from 'components/openRules/rules';
import { setUserInfo } from '../../redux/slice/userInfo/userInfoSlice';
import { emptyBalance } from '../../redux/slice/user/userSlice';
import { emptyLoingUserData } from '../../redux/slice/userData/userDataSlice';
import UserAutoLogout from 'components/userAutoLogout';
import { getLogoByDomain } from 'utils/domainConfig';


function Header() {
    const userInfos = useSelector((state) => state.bets); // Use selector to access state
    const betData = useSelector((state) => state.data); // Use selector to access state
    const userInfo = useSelector((state) => state?.userInfo?.userdata); // get login user details
    UserAutoLogout();   // Auto logout after 2 hours

    const dispatch = useDispatch();
    const [balance, setBalance] = useState(0)
    const [exposure, setExposure] = useState(0)
    // const balance = userbalance?.balance;
    // const exposure = userbalance?.exposure;
    const [headerChange, setHeaderChange] = useState(false)
    const [balanceWithExp, setbalanceWithExp] = useState(0)


    // let balanceWithExp = balance - Math.abs(exposure);
    const navItems = [
        {
            'title': 'Home',
            'url': '/'
        },
        {
            'title': 'In-Play',
            'url': '/inplay'
        },
        {
            'title': 'Multi Markets',
            'url': '/multimarket'
        },
        {
            'title': 'Cricket',
            'url': '/allsport-highlight/4',
        },
        {
            'title': 'Tennis',
            'url': '/allsport-highlight/2',
        },
        {
            'title': 'Soccer',
            'url': '/allsport-highlight/1',
        },
        {
            'title': 'Horse Racing',
            'url': '/allsport-highlight/7',
        },
        {
            'title': 'Greyhound Racing',
            'url': '/allsport-highlight/4339',
        },
        {
            'title': 'Politics',
            'url': '/allsport-highlight/2378961',
        },
        {
            'title': 'Lottery',
            'url': '/allsport-highlight/66104',
        },
        {
            'title': 'Live Casino',
            'url': '/live-casino'
        },
        {
            'title': 'Virtual Sports',
            'url': '/virtual-sports'
        },
        {
            'title': 'Tips & Previews',
            'url': '/tips-previews'
        },
    ]
    const location = useLocation();

    useEffect(() => {
        if (location) {
            let casinoPath = location?.pathname?.split('/')[1];
            if (casinoPath === 'casino') {
                setHeaderChange(true)
            } else {
                setHeaderChange(false)
            }
        }
    }, [location])

    const ref = useRef(null);
    const [showEventInp, setShowEventInp] = useState(false)
    const [ageModalOpen, setAgeModalOpen] = useState(false);
    const [loginModel, setLoginModel] = useState(false);
    const [exposureModal, setExposureModal] = useState(false);


    const [showPassword, setShowPassword] = useState(false);
    const [myAccountListOpen, setMyAccountListOpen] = useState(false)
    const [openbets, setOpenbets] = useState(false)
    const [openRules, setOpenRules] = useState(false)

    // const [openBetShow, setOpenbetShow] = useState([])
    const openBetShow = userInfos?.bets?.exposureBets?.length > 0 ? userInfos?.bets?.exposureBets : [];

    const [loadBalance, setLoadBalance] = useState(true)
    const [isDisabled, setIsDisabled] = useState(false);

    const navigate = useNavigate();
    // let pthh = MainBalance - Math.abs(exposure);
    const [user_nameValidationError, setUser_NameValidationError] = useState("Please enter username");
    const [passwordValidationError, setPasswordValidationError] = useState("Please enter password");
    const [validationError, setValidationError] = useState("");

    const [formData, setformData] = useState({
        user_name: '',
        password: '',
        site_code: Appconfig.sitecodes,
        user_type: "User"
    });

    const handleHideDropdown = (event) => {
        if (event.key === "Escape") {
            setMyAccountListOpen(false);
        }
    };

    const handleClickOutside = event => {
        if (ref.current && !ref.current.contains(event.target)) {
            setMyAccountListOpen(false);
        }
    };
    useEffect(() => {
        document.addEventListener("keydown", handleHideDropdown, true);
        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("keydown", handleHideDropdown, true);
            document.removeEventListener("click", handleClickOutside, true);
        };
    });


    const showAgeModal = () => {
        setAgeModalOpen(true);
    };
    const handleAgeOk = () => {
        setAgeModalOpen(false);
    };
    const handleCancel = () => {
        setAgeModalOpen(false);
    };
    const handleExposureOk = () => {
        setExposureModal(false);
    };
    const handleExposureCancel = () => {
        setExposureModal(false);
    };



    function checkValidation() {
        let errorText;
        if (formData.user_name.trim() === "") {
            setUser_NameValidationError('Please enter username')
            document.querySelector('.username-error').classList.remove('hidden');
        }
        if (formData.password === "") {
            document.querySelector('.password-error').classList.remove('hidden');
            setPasswordValidationError('Please enter password')
        }
        const regex = /^[a-zA-Z0-9]*$/;
        if (!regex.test(formData.user_name)) {
            document.querySelector('.username-error').classList.remove('hidden');
            setUser_NameValidationError('Username is only allow a-z and 0-9.')
            return false;
        }

        setValidationError(errorText);
        if (regex.test(formData.user_name) && formData.password !== "") {
            return true
        }
        return false;

    }
    const handleInputChange = (event) => {
        setformData({
            ...formData,
            [event.target.name]: event.target.value
        });
        if (event.target.name === 'user_name') {
            document.querySelector('.username-error').classList.add('hidden');
        }
        if (event.target.name === 'password') {
            document.querySelector('.password-error').classList.add('hidden');
        }

    };

    const handleSubmit = (event) => {

        if (checkValidation()) {

            setIsDisabled(true);

            var config = {
                method: 'post',
                url: `${Appconfig.apiUrl}users/userAuthenticate`,
                headers: {
                    'Content-Type': 'application/json',

                },

                data: JSON.stringify(formData)

            };
            axios(config)
                .then(function (response) {
                    setIsDisabled(false);

                    if (response.data.result != 0) {
                        NotificationManager.success(response.data.resultMessage, '', 3000);
                        dispatch(setUserInfo(response.data.resultData))
                        localStorage.setItem("loginTime", new Date().getTime().toString());

                        // localStorage.setItem('userdata', JSON.stringify(response.data.resultData && response.data.resultData));
                        localStorage.setItem('login_token', response.data.resultData && response.data.resultData.login_token);
                        formData.password = "";
                        formData.user_name = "";
                        setTimeout(() => {
                            navigate('/')
                        }, 1000)
                    }
                    else {
                        setValidationError(response.data.resultMessage);
                        // errorNotification();
                        NotificationManager.error('Invalid Login Credential!', '', 3000);
                    }

                })
                .catch(function (error) {
                    setIsDisabled(false);

                    console.log(error);
                });

        }

    }


    const logout = () => {
        localStorage.removeItem('userdata');
        localStorage.removeItem('login_token');
        localStorage.removeItem('loginTime');
        dispatch(emptyUserInfo());
        dispatch(emptyBalance());
        dispatch(emptyOpenBets());
        dispatch(emptyLoingUserData());
        setMyAccountListOpen(false)

        navigate('/');
    }

    function getBalance() {
        var data = JSON.stringify({
            user_id: userInfo?._id,
        });

        var config = {
            method: "post",
            url: `${Appconfig.apiUrl}ledger/getUserBalance`,
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                if (response.data.result == 0) {
                } else {
                    setBalance(response.data.resultData?.balance)
                    setExposure(response.data.resultData?.exposure)

                    let getBal = response.data.resultData?.balance;
                    let getExp = response.data.resultData?.exposure
                    let balWithoutExp = getBal - Math.abs(getExp);

                    setbalanceWithExp(balWithoutExp);

                    // setBalanceData(response.data.resultData)
                    setLoadBalance(false)
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    useEffect(() => {
        if (userInfo) {
            dispatch(getAllBets({
                user_id: userInfo?._id,
            }))
        }

    }, [userInfo?._id])


    useEffect(() => {
        if (userInfo) {
            getBalance();
        }
    }, [userInfo, betData])


    useEffect(() => {
        const chkLog = window.setInterval(function () {
            if (userInfo) {
                checkNewLogin();
            }
        }, 5000);
        return () => {
            clearInterval(chkLog)
        }
    }, [])

    const checkNewLogin = () => {
        var data = JSON.stringify({
            "login_token": userInfo.login_token,
            "user_id": userInfo._id
        });

        var config = {
            method: 'post',
            url: `${Appconfig.apiUrl}userToken/getToken`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };
        axios(config)
            .then(function (response) {
                try {
                    if (response.data.result) {
                    }
                    else {
                        localStorage.removeItem('userdata');
                        localStorage.removeItem('login_token');
                        localStorage.removeItem('loginTime');
                        dispatch(emptyUserInfo());
                        dispatch(emptyBalance());
                        dispatch(emptyOpenBets());
                        dispatch(emptyLoingUserData());
                        setMyAccountListOpen(false)
                        window.location.href = "/login";
                    }
                } catch (e) {
                    // postErrorToslack(e.message);
                }
            })
            .catch(function (error) {
                // postErrorToslack(error.message);
                console.log(error);
            });
    }


    return (
        <>
            <NotificationContainer />
            {/* Desktop */}
            <div className='hidden lg:block fixed z-[999]'>
                <div className='flex flex-row items-center justify-between w-full bg-[linear-gradient(-180deg,#010101_0,_#0e0e0e_100%)] h-[70px]'>
                    {/* Before login */}
                    {!userInfo && (
                        <>
                            <div className='col-span-7 flex items-center justify-between'>
                                <div>
                                    <img alt='' className='w-[10rem] h-[4.25rem]'
                                        src={getLogoByDomain()} // Using the common function
                                    />
                                </div>
                                {showEventInp && (
                                    <div className="relative w-[17.5rem] username-inp">
                                        <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                                            <IoSearch />
                                        </div>
                                        <input type="text" id="voice-search" className="bg-gray-50 border border-gray-300 text-[1rem] block w-full ps-10 outline-none " placeholder="Search Events" required style={{ borderRadius: '.25rem', color: '#212529' }} />
                                        <button type="button" className="absolute inset-y-0 end-0 flex items-center pe-3">
                                            <IoMdClose />
                                        </button>
                                    </div>
                                )}
                            </div>
                            <div className='grid col-span-5 px-[40px] items-center text-white text-2xl username-inp'>
                                <ul className='flex  items-center'>
                                    <li className='cursor-pointer mr-[20px]' onClick={() => setShowEventInp(!showEventInp)}>
                                        <FaSearchPlus />
                                    </li>
                                    <li className='username-inp flex'>
                                        <input
                                            value={formData.user_name}
                                            onChange={handleInputChange}
                                            type='text'
                                            name="user_name"
                                            id="user_name"
                                            placeholder='Username'
                                            maxLength={30}
                                            className=' text-[.875rem] font-normal h-[1.563rem] bg-white outline-none'
                                            style={{ borderRadius: '.25rem', padding: '.375rem .75rem', color: '#212529' }}
                                        />
                                        <span className="absolute top-[50px] username-error hidden  text-[0.813rem] text-white leading-[14px]">
                                            <div className='leading-[14px] '>{user_nameValidationError}</div>
                                        </span>
                                    </li>
                                    <li className='password-inp ml-[17px] mr-[20px] flex'>
                                        <input
                                            value={formData.password}
                                            onChange={handleInputChange}
                                            type='password'
                                            minLength={6}
                                            id="password"
                                            name="password"
                                            placeholder='Passwrod'
                                            className='text-[.875rem] font-normal h-[1.563rem] outline-none'
                                            style={{ borderRadius: '.25rem', padding: '.375rem .75rem', color: '#212529' }}
                                        />
                                        <span className="absolute top-[50px] password-error hidden  text-[0.813rem] text-white leading-[14px]">
                                            <div className='leading-[14px]'>{passwordValidationError}</div>
                                        </span>
                                    </li>
                                    <li className='w-[6rem]'>
                                        <button className='flex items-center justify-center w-full gap-1 h-[1.563rem] bg-[linear-gradient(-180deg,_#bb1c00_0%,_#bb1c00_100%)] text-white text-sm font-bold' style={{ borderRadius: '0.242rem' }}
                                            onClick={handleSubmit}
                                            disabled={isDisabled}
                                        >
                                            Login
                                            <FaSignInAlt />
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </>
                    )}
                    {/* after login */}
                    {userInfo && (
                        <>
                            <div className='flex items-center text-[white]'>
                                <img alt='' className='block cursor-pointer w-[160px] h-[68px] relative top-[.5px] text-[white]'
                                    src={getLogoByDomain()} // Using the common function
                                />
                            </div>

                            <div className='flex items-center text-[white]'>
                                <ul className='relative [list-style:none]  flex items-center pl-8 text-[white]'>
                                    <li className='!mr-[20px] relative z-10 !float-left text-[white]'>
                                        <FaSearchPlus className='text-[white] text-[1.5rem] ml-[10px] float-right mt-[5px]' />
                                    </li>
                                </ul>
                                <div className='flex items-center relative text-[white]'>
                                    <div className='mr-[15px] text-[white] text-[.75rem] font-bold text-left '>
                                        {loadBalance && (
                                            <div className="loadingBalance w-full ">
                                                <span ></span>
                                                <span ></span>
                                                <span ></span>
                                                <span ></span>
                                                <span ></span>
                                                <span ></span>
                                                <span ></span>
                                            </div>
                                        )}
                                        {!loadBalance && (
                                            <div className='text-center ' >
                                                <p className='text-center mb-[.4rem]' >
                                                    Main&nbsp;<strong >
                                                        PTI&nbsp;<span className='text-center'>{userInfo ? balance && Number(balanceWithExp).toFixed(2) : ''}</span>
                                                    </strong>
                                                </p>
                                                <p className='text-center'>
                                                    Exposure
                                                    <a className='cursor-pointer'>
                                                        <strong onClick={() => setExposureModal(true)}>
                                                            &nbsp;(
                                                            <span className='text-center text-[red]'>{userInfo ? exposure && Number(exposure).toFixed(2) : ''}</span>
                                                            )
                                                        </strong>
                                                    </a>
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                    <div>
                                        <span className='ml-[4px] relative leading-[20px] flex mr-[7px] rounded-[2px] float-left h-[25px] bg-[linear-gradient(180deg,_#2e2e2e,_#282828_42%,_#2e2e2e)] [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] text-[#ffffff] w-[25px] px-[4px] py-[0] items-center justify-center'>
                                            <button className='text-[#ffffff] leading-[20px]'
                                                onClick={() => {
                                                    getBalance()
                                                    setLoadBalance(true)
                                                }}
                                            >
                                                <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8 0C5 0 2.4 1.6 1.1 4.1L0 3V7H4L2.5 5.5C3.5 3.5 5.6 2 8 2C11.3 2 14 4.7 14 8C14 11.3 11.3 14 8 14C6.2 14 4.6 13.2 3.5 11.9L2 13.2C3.4 14.9 5.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0Z" fill="white" />
                                                </svg>
                                            </button>
                                        </span>
                                    </div>
                                    <div className='relative bottom-[.5px] text-[white]'>
                                        <button className='w-[110px] relative leading-[25px] bg-[0_-800px] float-left text-[.75rem] no-underline bg-[linear-gradient(180deg,_#2e2e2e,_#282828_42%,_#2e2e2e)] mr-[20px] [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] flex rounded-[2px] text-[white] pl-[7px] pr-[4px] py-[0] justify-between items-center'
                                            onClick={() => setMyAccountListOpen(true)}
                                        >
                                            <FaUser className='text-[#fd8f3b]' />
                                            My Account
                                            <IoMdArrowDropdown className='text-[1rem] text-[#fd8f3b]' />
                                        </button>
                                        {myAccountListOpen && (
                                            <ul ref={ref} className='absolute m-0 [transform:translate3d(0,_27px,_0)!important] [box-shadow:0_4px_5px_#00000080] pb-0 leading-normal block w-[222px] h-[256px] !right-[20px] float-left min-w-[10rem] p-0 text-[.875rem] text-[black] text-left [list-style:none] bg-[white] bg-clip-padding border-[1px] border-[#c8ced3] rounded-[.25rem]'>
                                                <li className='leading-normal text-[.875rem] text-[black] [list-style:none]'>
                                                    <div className='block mb-0 text-[.765625rem] text-[black] bg-[#e4e7ea] whitespace-nowrap px-[10px] py-[4.5px] border-b-[1px] border-b-[#ccc] !text-left'>
                                                        <strong className='text-[.765625rem] text-[black] !text-left leading-[1.5]'>{userInfo && userInfo?.user_name}</strong>
                                                    </div>
                                                    <Link to={'/myprofile'} className='min-w-[220px] no-underline h-[26px] leading-[11px] px-[10px] py-[5px] border-b-[1px] border-b-[#c8ced3] block w-full clear-both font-normal text-[#212529] [text-align:inherit] whitespace-nowrap bg-transparent border-[0] hover:bg-[#e4e7ea]' onClick={() => setMyAccountListOpen(false)}>My Profile</Link>
                                                    <Link to={'/rolling-commission'} className='min-w-[220px] no-underline h-[26px] leading-[11px] px-[10px] py-[5px] border-b-[1px] border-b-[#c8ced3] block w-full clear-both font-normal text-[#212529] [text-align:inherit] whitespace-nowrap bg-transparent border-[0] hover:bg-[#e4e7ea]' onClick={() => setMyAccountListOpen(false)}>Rolling Commission</Link>
                                                    <Link to={'/account-statement'} className='min-w-[220px] no-underline h-[26px] leading-[11px] px-[10px] py-[5px] border-b-[1px] border-b-[#c8ced3] block w-full clear-both font-normal text-[#212529] [text-align:inherit] whitespace-nowrap bg-transparent border-[0] hover:bg-[#e4e7ea]' onClick={() => setMyAccountListOpen(false)}>Account Statement</Link>
                                                    <Link to={'/bet-history'} className='min-w-[220px] no-underline h-[26px] leading-[11px] px-[10px] py-[5px] border-b-[1px] border-b-[#c8ced3] block w-full clear-both font-normal text-[#212529] [text-align:inherit] whitespace-nowrap bg-transparent border-[0] hover:bg-[#e4e7ea]' onClick={() => setMyAccountListOpen(false)}>Bets History</Link>
                                                    <Link to={'/profit-loss'} className='min-w-[220px] no-underline h-[26px] leading-[11px] px-[10px] py-[5px] border-b-[1px] border-b-[#c8ced3] block w-full clear-both font-normal text-[#212529] [text-align:inherit] whitespace-nowrap bg-transparent border-[0] hover:bg-[#e4e7ea]' onClick={() => setMyAccountListOpen(false)}>Profit & Loss</Link>
                                                    <Link to={'/password-history'} className='min-w-[220px] no-underline h-[26px] leading-[11px] px-[10px] py-[5px] border-b-[1px] border-b-[#c8ced3] block w-full clear-both font-normal text-[#212529] [text-align:inherit] whitespace-nowrap bg-transparent border-[0] hover:bg-[#e4e7ea]' onClick={() => setMyAccountListOpen(false)}>Password History</Link>
                                                    <Link to={'/activity-log'} className='min-w-[220px] no-underline h-[26px] leading-[11px] px-[10px] py-[5px] border-b-[1px] border-b-[#c8ced3] block w-full clear-both font-normal text-[#212529] [text-align:inherit] whitespace-nowrap bg-transparent border-[0] hover:bg-[#e4e7ea]' onClick={() => setMyAccountListOpen(false)}>Activity Log</Link>
                                                    <div className='min-w-[220px] no-underline h-[39px] px-[10px] py-[9px] border-b-[none] leading-[11px] w-[220px] block clear-both font-normal text-[#212529] [text-align:inherit] whitespace-nowrap bg-transparent border-[0]'>
                                                        <button className='w-full pt-[7px] px-[10px] pb-[5px] font-bold h-[27px] leading-[10px] text-[0.813rem] mr-[4px] rounded-[3.6px] text-[white] bg-[linear-gradient(-180deg,_#2E4B5E_0%,_#243A48_82%)] flex justify-center items-center'
                                                            onClick={() => logout()}
                                                        >
                                                            LOGOUT
                                                            <svg className='w-[20px]' width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M13.8062 6.96533L9.13934 11.777C8.72265 12.2066 8.0004 11.9059 8.0004 11.2901V8.54059H4.22243C3.85297 8.54059 3.55573 8.23413 3.55573 7.8532V5.10366C3.55573 4.72273 3.85297 4.41627 4.22243 4.41627H8.0004V1.66673C8.0004 1.05381 8.71988 0.750214 9.13934 1.17983L13.8062 5.99153C14.0646 6.26076 14.0646 6.6961 13.8062 6.96533ZM5.3336 11.6338V10.4882C5.3336 10.2991 5.18359 10.1445 5.00025 10.1445H2.6668C2.17511 10.1445 1.77787 9.73492 1.77787 9.22797V3.72889C1.77787 3.22194 2.17511 2.81237 2.6668 2.81237H5.00025C5.18359 2.81237 5.3336 2.65771 5.3336 2.46868V1.32304C5.3336 1.134 5.18359 0.979342 5.00025 0.979342H2.6668C1.1945 0.979342 0 2.21091 0 3.72889V9.22797C0 10.7459 1.1945 11.9775 2.6668 11.9775H5.00025C5.18359 11.9775 5.3336 11.8229 5.3336 11.6338Z" fill="white" />
                                                            </svg>
                                                        </button>
                                                    </div>

                                                </li>
                                            </ul>
                                        )}
                                    </div>

                                </div>
                            </div>
                        </>
                    )}
                </div>
                <div className='grid grid-cols-12 gap-4 bg-[linear-gradient(-180deg,#f6a21e_0,_#cb7e05_100%)]'>
                    <ul className='flex ml-[25px] mr-[0] my-[0] font-bold'>
                        {navItems.map((item, index) => (
                            <li key={index} className='flex px-[10px] py-[0] leading-[30px]' style={{ borderRight: '1px solid #797777' }}>
                                {/* <Link to={item.url ? item.url : '#'} className={` font-bold text-[0.813rem] w-max ${location.pathname == item.url ? `text-white` : `text-black`}`}>{item.title}</Link> */}
                                <span to={item.url ? item.url : '#'} className={`cursor-pointer font-bold text-[0.813rem] w-max ${location.pathname == item.url ? `text-white` : `text-black`}`}
                                    onClick={() => item.url == '/multimarket' || item.url == '/virtual-sports' ? setAgeModalOpen(true) : navigate(item.url)}
                                >{item.title}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* Mobile */}
            <div className='flex w-full lg:hidden fixed z-[999]'>
                <div className='grid grid-cols-12 w-full h-[56px] bg-[linear-gradient(-180deg,#010101_0,_#0e0e0e_100%)]'>
                    {/* Before Login */}
                    {!userInfo && (
                        <div className='col-span-12 flex items-center'>
                            <div className='flex items-center justify-between w-full'>
                                <div className='flex items-center ml-[3px]'>
                                    <img alt='' className='relative left-[4px] w-[6rem] h-[2.438rem]'
                                        src={getLogoByDomain()} // Using the common function
                                    />
                                </div>
                                <div className='flex items-center text-center text-black font-semibold'>
                                    <div className='flex items-center'>
                                        <button className='flex h-[28px] items-center justify-center bg-[linear-gradient(-180deg,_#F6A21E_0%,_#F6A21E_100%)] text-[.765625rem] leading-normal rounded-[.2rem] h-[33px] w-[80px] mr-[8px] ml-[4.5px] mb-[2px]'
                                            onClick={showAgeModal}
                                        >
                                            <b> Login</b>
                                            <FaSignInAlt className='ml-[.25rem] p-[.5px]' />
                                        </button>
                                        <Modal className='age-model' open={ageModalOpen} footer={null} onOk={handleAgeOk} centered onCancel={handleCancel}>
                                            <div className='grid grid-cols-12'>
                                                <div className='col-span-12 mt-[20px]'>
                                                    <div className='text-[1rem]'>
                                                        Non-Gambling Territories.
                                                    </div>
                                                    <hr className='mx-[0] my-4' />
                                                    <div className='text-[0.875rem] mb-[35px]'>
                                                        Connecting to our site from non gambling countries, it will be User's responsibility to ensure that their use of the service is lawful.
                                                    </div>
                                                </div>

                                                <div className='col-span-12'>
                                                    <div className='text-[1rem]'>
                                                        Underage gambling is prohibited.
                                                    </div>
                                                    <hr className='mx-[0] my-4' />
                                                    <div className='text-[0.875rem] mb-[35px]'>
                                                        Please confirm if you are 18 years old and above as of today.
                                                    </div>
                                                </div>


                                                <div className='col-span-12 flex justify-center '>
                                                    <button className='bg-[#ffffff] text-[#000000] px-[5px] text-[0.813rem] h-[30px] w-[90px] outline-[0] rounded-[4px] font-bold flex-[.3] mr-[10px] border-[1px] border-[solid] border-[#ffffff]' onClick={() => {
                                                        setAgeModalOpen(false)
                                                        navigate('/login')
                                                    }
                                                    }>
                                                        <span>Confirm</span>
                                                    </button>

                                                    <button className='text-[0.813rem] h-[30px] px-[5px] w-[90px] outline-[0] rounded-[4px] font-bold flex-[.3] mr-[10px] bg-[#000000] text-[#ffffff] border-[1px] border-[solid] border-[#ffffff]' onClick={() => setAgeModalOpen(false)}>
                                                        <span>Exit</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </Modal>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* After Login */}
                    {userInfo && (
                        <div className='col-span-12'>
                            <Modal className='recent-result-modal relative top-1 lg:top-7 w-[500px]' open={exposureModal} onOk={handleExposureOk} footer={null} onCancel={handleExposureCancel}>
                                <div className='grid grid-cols-12'>
                                    <div className='col-span-12 flex rounded-t-[5px] items-center h-[35px] justify-between py-[6px] px-[15px] bg-[linear-gradient(-180deg,_#010101_0%,_#0e0e0e_100%)] text-[#ffffff]'>
                                        <span className='leading-normal text-[.938rem]'> Exposure Detail </span>
                                        <button type="button" className='text-[1.3rem] font-bold' onClick={() => setExposureModal(false)}>×</button>
                                    </div>
                                    <div className='col-span-12 p-[5px]'>

                                        <table className='border-collapse border border-slate-500 '>
                                            <thead className='align-bottom text-[.75rem]'>
                                                <th className='w-[20%] p-[7px] border border-slate-600 bg-[#dee2e6] font-bold text-[15px]'>Sport Name</th>
                                                <th className='w-[40%] p-[7px] border border-slate-600 bg-[#dee2e6] font-bold text-[15px]'>Event Name</th>
                                                <th className='w-[20%] p-[7px] border border-slate-600 bg-[#dee2e6] font-bold text-[15px]'>Market Name</th>
                                                <th className='w-[20%] p-[7px] border border-slate-600 bg-[#dee2e6] font-bold text-[15px]'>Trade</th>
                                            </thead>
                                            <tbody>
                                                {
                                                    openBetShow.length ? openBetShow.map(bets => {
                                                        return (
                                                            <tr>
                                                                <td className='p-[7px] border border-slate-600 font-bold text-[14px]'>{bets.event_type == 4 ? 'Cricket' : bets.event_type == 2 ? 'Tennis' : bets.event_type == 1 ? 'Soccer' : 'Casino'}</td>
                                                                <td className='p-[7px] border border-slate-600 font-bold text-[14px]'>
                                                                    <Link to={`${[1, 2, 4].includes(bets?.event_type) ? `/fullMarket/${bets?.match_id}/Going Inplay` : `/casino/${bets?.event_type}`}`} onClick={() => setExposureModal(false)} className='text-[#2789ce]'>{bets.event_name}</Link>
                                                                </td>
                                                                <td className='p-[7px] border border-slate-600 font-bold text-[14px]'>{bets.market_name}</td>
                                                                <td className='p-[7px] border border-slate-600 font-bold text-[14px]'>{bets.totalByMatch}</td>
                                                            </tr>
                                                        )
                                                    })
                                                        :
                                                        ''
                                                }


                                            </tbody>

                                        </table>
                                    </div>
                                </div>

                            </Modal>
                            {
                                headerChange ?
                                    <>
                                        <div className='flex justify-between h-[58px] text-center text-[white]'>
                                            <div className='flex items-center text-center text-[white]'>
                                                <button type='button' className='relative bottom-[1.5px] text-[14px] !text-[white] [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] bg-[linear-gradient(-180deg,#010101_0,_#0e0e0e_100%)] h-[9.33333vw] leading-[5.33333vw] font-bold rounded-[1.06667vw] border-[1px] border-[solid] border-[#0b1933] px-[2.86667vw] py-[2.6vw] ml-px justify-center items-center flex' onClick={() => {
                                                    setOpenRules(true)
                                                }}>
                                                    Rules
                                                </button>
                                                <Modal title={'Open Rules'} className='openbets-modal ' onCancel={() => setOpenRules(false)} open={openRules} mask={null} footer={null} >
                                                    <OpenRules />
                                                </Modal>
                                            </div>
                                            <div className='flex items-center text-center text-[white] '>
                                                <Link to={'/live-casino'} className='relative bottom-[1.5px] text-[12px] !text-[white] [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] bg-[linear-gradient(-180deg,#010101_0,_#0e0e0e_100%)] h-[9.33333vw] leading-[3.33333vw] font-bold rounded-[1.06667vw] border-[1px] border-[solid] border-[#0b1933] px-[2.86667vw] py-[2.6vw] ml-px justify-center items-center flex' >
                                                    GAMING <br /> LOBBY
                                                </Link>
                                            </div>
                                            <div className='flex items-center text-center text-[white]'>

                                                {loadBalance && (
                                                    <div className="loadingBalance w-full ">
                                                        <span ></span>
                                                        <span ></span>
                                                        <span ></span>
                                                        <span ></span>
                                                        <span ></span>
                                                        <span ></span>
                                                        <span ></span>
                                                    </div>
                                                )}
                                                {!loadBalance && (<div className='flex items-center relative text-center text-[white]'>
                                                    <div className='block mr-[10px] text-[.75rem] font-bold text-left text-[white]'>
                                                        <div className='text-center text-[.75rem] font-bold text-[white]'>
                                                            <span className='block relative bottom-[3px] left-[8px] text-[.75rem] font-bold text-[white]'>{`Main `}<strong>PTI<span>{` ${balance && Number(balanceWithExp).toFixed(2)} `}</span></strong></span>
                                                            <span className='ml-[20px] relative top-px right-[2px] block text-[.75rem] font-bold text-[white]'>{` Exposure `}<a className='text-[white] cursor-pointer text-[.75rem] font-bold'>
                                                                <strong className='text-[white] text-[.75rem] font-[bolder]'>
                                                                    (<strong onClick={() => setExposureModal(true)}>
                                                                        <span className='text-[red] text-[0.813rem]'>{userInfo ? balance && Math.abs(Number(exposure)).toFixed(2) : ''}</span>
                                                                    </strong>)
                                                                </strong>
                                                            </a>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>)}

                                                <div className='flex text-center text-[white] ml-[10px]'>
                                                    <div className='relative bottom-px right-[2px] text-[white] [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] bg-[linear-gradient(-180deg,#010101_0,_#0e0e0e_100%)] h-[9.33333vw] leading-[5.33333vw] font-bold rounded-[5px] border-[1px] border-[solid] border-[#0b1933] px-[1.86667vw] py-[2.6vw] justify-center items-center flex mr-[6px]'>
                                                        <button type='button' className='text-[white] leading-[5.33333vw] font-bold text-center'
                                                            onClick={() => {
                                                                getBalance()
                                                                setLoadBalance(true)
                                                            }}
                                                        >
                                                            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                <path d="M10 4.029c1.635 0 3.144.36 4.527 1.079 1.365.703 2.443 1.655 3.233 2.854.827 1.247 1.24 2.59 1.24 4.028 0 1.44-.413 2.782-1.24 4.03-.79 1.214-1.868 2.173-3.233 2.877A9.596 9.596 0 0 1 10 20a9.596 9.596 0 0 1-4.527-1.103c-1.365-.704-2.443-1.663-3.233-2.878C1.413 14.772 1 13.43 1 11.99h2.263c0 1.088.301 2.09.903 3.01.602.92 1.42 1.647 2.452 2.182 1.033.536 2.16.804 3.382.804s2.349-.268 3.382-.804c1.033-.535 1.85-1.263 2.452-2.182.602-.92.903-1.922.903-3.01 0-1.087-.301-2.09-.903-3.01-.602-.918-1.42-1.646-2.452-2.181-1.033-.536-2.16-.804-3.382-.804v4.029L4.368 5.012 10 0v4.029z" fill="currentColor"></path>
                                                            </svg>
                                                        </button>
                                                    </div>

                                                    <div className='flex items-center text-center text-[white]'>
                                                        <button type='button' className='relative bottom-[1.5px] text-[14px] !text-[white] [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] bg-[linear-gradient(-180deg,#010101_0,_#0e0e0e_100%)] h-[9.33333vw] leading-[5.33333vw] font-bold rounded-[1.06667vw] border-[1px] border-[solid] border-[#0b1933] px-[2.86667vw] py-[2.6vw] ml-px justify-center items-center flex' onClick={() => {
                                                            setOpenbets(true)
                                                        }}>
                                                            <svg className='w-[20px] h-[20px]' xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                                <path fill="currentColor" fillRule="nonzero" d="M19.314 6.38c-.41-1.052-.987-2.018-1.708-2.862-1.49-1.75-3.574-2.97-5.94-3.368C11.125.06 10.57 0 10 0c-.57 0-1.124.06-1.667.15-2.365.398-4.447 1.62-5.94 3.367-.72.845-1.297 1.81-1.707 2.863C.25 7.504 0 8.722 0 10c0 1.175.213 2.297.585 3.344.38 1.066.927 2.05 1.62 2.914 1.503 1.868 3.662 3.178 6.128 3.592.543.09 1.098.15 1.667.15.57 0 1.124-.06 1.667-.15 2.466-.414 4.625-1.724 6.127-3.592.694-.864 1.242-1.848 1.62-2.913.373-1.047.586-2.17.586-3.345 0-1.278-.25-2.496-.686-3.62zm-1.173.678l-1.747 1.01c-.332-1.095-.937-2.07-1.735-2.848l1.764-1.02c.746.826 1.333 1.793 1.72 2.858zM15.348 10c0 2.948-2.398 5.347-5.347 5.347-2.95 0-5.347-2.4-5.347-5.347 0-2.948 2.398-5.347 5.347-5.347 2.95 0 5.347 2.4 5.347 5.347zM10 1.333c.57 0 1.127.06 1.667.165v2.04c-.534-.137-1.09-.218-1.667-.218-.576 0-1.133.08-1.667.22V1.497c.54-.106 1.097-.165 1.667-.165zM3.578 4.2l1.765 1.02c-.8.778-1.404 1.753-1.736 2.847L1.86 7.057c.385-1.065.973-2.03 1.718-2.856zm-1.82 8.467l1.775-1.024c.282 1.112.84 2.11 1.604 2.923L3.38 15.58c-.717-.848-1.272-1.834-1.622-2.913zm8.242 6c-.57 0-1.127-.06-1.667-.165v-2.04c.534.137 1.09.218 1.667.218.576 0 1.133-.08 1.667-.22v2.042c-.54.106-1.097.165-1.667.165zm6.62-3.087l-1.757-1.014c.763-.81 1.322-1.81 1.604-2.923l1.775 1.025c-.35 1.078-.905 2.064-1.622 2.912zm-6.003-6.325c1.174.418 1.647.966 1.647 1.862 0 .887-.62 1.644-1.755 1.843v.514c0 .27-.218.488-.485.488s-.483-.218-.483-.488v-.444c-.39-.018-.772-.088-1.098-.187-.332-.1-.526-.448-.44-.787l.005-.017c.035-.145.13-.265.258-.335.13-.07.28-.08.42-.03.328.117.708.2 1.11.2.563 0 .947-.22.947-.618 0-.38-.315-.618-1.045-.867-1.056-.358-1.775-.856-1.775-1.822 0-.877.61-1.564 1.667-1.773v-.458c0-.285.24-.513.53-.486.25.025.436.247.436.5v.375c.347.016.634.062.875.125.315.082.504.406.423.723l-.01.034c-.034.14-.124.258-.248.328s-.27.086-.407.043c-.238-.075-.538-.137-.908-.137-.642 0-.848.28-.848.56 0 .327.344.536 1.183.855z"></path>
                                                            </svg>
                                                        </button>
                                                        {/* <OpenBets open={openbets} /> */}
                                                        <Modal title={'Open Bets'} className='openbets-modal ' onCancel={() => setOpenbets(false)} open={openbets} mask={null} footer={null} >
                                                            <OpenBets />
                                                        </Modal>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className='flex justify-between h-[58px] text-center text-[white]'>
                                            <div className='flex items-center text-center text-[white]'>
                                                <button type='button' className='relative bottom-[1.5px] text-[14px] !text-[white] [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] bg-[linear-gradient(-180deg,#010101_0,_#0e0e0e_100%)] h-[9.33333vw] leading-[5.33333vw] font-bold rounded-[1.06667vw] border-[1px] border-[solid] border-[#0b1933] px-[2.86667vw] py-[2.6vw] ml-px justify-center items-center flex' onClick={() => {
                                                    setOpenbets(true)
                                                }}>
                                                    <svg className='w-[20px] h-[20px]' xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                        <path fill="currentColor" fillRule="nonzero" d="M19.314 6.38c-.41-1.052-.987-2.018-1.708-2.862-1.49-1.75-3.574-2.97-5.94-3.368C11.125.06 10.57 0 10 0c-.57 0-1.124.06-1.667.15-2.365.398-4.447 1.62-5.94 3.367-.72.845-1.297 1.81-1.707 2.863C.25 7.504 0 8.722 0 10c0 1.175.213 2.297.585 3.344.38 1.066.927 2.05 1.62 2.914 1.503 1.868 3.662 3.178 6.128 3.592.543.09 1.098.15 1.667.15.57 0 1.124-.06 1.667-.15 2.466-.414 4.625-1.724 6.127-3.592.694-.864 1.242-1.848 1.62-2.913.373-1.047.586-2.17.586-3.345 0-1.278-.25-2.496-.686-3.62zm-1.173.678l-1.747 1.01c-.332-1.095-.937-2.07-1.735-2.848l1.764-1.02c.746.826 1.333 1.793 1.72 2.858zM15.348 10c0 2.948-2.398 5.347-5.347 5.347-2.95 0-5.347-2.4-5.347-5.347 0-2.948 2.398-5.347 5.347-5.347 2.95 0 5.347 2.4 5.347 5.347zM10 1.333c.57 0 1.127.06 1.667.165v2.04c-.534-.137-1.09-.218-1.667-.218-.576 0-1.133.08-1.667.22V1.497c.54-.106 1.097-.165 1.667-.165zM3.578 4.2l1.765 1.02c-.8.778-1.404 1.753-1.736 2.847L1.86 7.057c.385-1.065.973-2.03 1.718-2.856zm-1.82 8.467l1.775-1.024c.282 1.112.84 2.11 1.604 2.923L3.38 15.58c-.717-.848-1.272-1.834-1.622-2.913zm8.242 6c-.57 0-1.127-.06-1.667-.165v-2.04c.534.137 1.09.218 1.667.218.576 0 1.133-.08 1.667-.22v2.042c-.54.106-1.097.165-1.667.165zm6.62-3.087l-1.757-1.014c.763-.81 1.322-1.81 1.604-2.923l1.775 1.025c-.35 1.078-.905 2.064-1.622 2.912zm-6.003-6.325c1.174.418 1.647.966 1.647 1.862 0 .887-.62 1.644-1.755 1.843v.514c0 .27-.218.488-.485.488s-.483-.218-.483-.488v-.444c-.39-.018-.772-.088-1.098-.187-.332-.1-.526-.448-.44-.787l.005-.017c.035-.145.13-.265.258-.335.13-.07.28-.08.42-.03.328.117.708.2 1.11.2.563 0 .947-.22.947-.618 0-.38-.315-.618-1.045-.867-1.056-.358-1.775-.856-1.775-1.822 0-.877.61-1.564 1.667-1.773v-.458c0-.285.24-.513.53-.486.25.025.436.247.436.5v.375c.347.016.634.062.875.125.315.082.504.406.423.723l-.01.034c-.034.14-.124.258-.248.328s-.27.086-.407.043c-.238-.075-.538-.137-.908-.137-.642 0-.848.28-.848.56 0 .327.344.536 1.183.855z"></path>
                                                    </svg>
                                                    &nbsp;Bets
                                                </button>
                                                {/* <OpenBets open={openbets} /> */}
                                                <Modal title={'Open Bets'} className='openbets-modal ' onCancel={() => setOpenbets(false)} open={openbets} mask={null} footer={null} >
                                                    <OpenBets />
                                                </Modal>
                                            </div>
                                            <div className='flex items-center text-center text-[white]'>

                                                {loadBalance && (
                                                    <div className="loadingBalance w-full ">
                                                        <span ></span>
                                                        <span ></span>
                                                        <span ></span>
                                                        <span ></span>
                                                        <span ></span>
                                                        <span ></span>
                                                        <span ></span>
                                                    </div>
                                                )}
                                                {!loadBalance && (<div className='flex items-center relative text-center text-[white]'>
                                                    <div className='block mr-[10px] text-[.75rem] font-bold text-left text-[white]'>
                                                        <div className='text-center text-[.75rem] font-bold text-[white]'>
                                                            <span className='block relative bottom-[3px] left-[8px] text-[.75rem] font-bold text-[white]'>{`Main `}<strong>PTI<span>{` ${balance && Number(balanceWithExp).toFixed(2)} `}</span></strong></span>
                                                            <span className='ml-[20px] relative top-px right-[2px] block text-[.75rem] font-bold text-[white]'>{` Exposure `}<a className='text-[white] cursor-pointer text-[.75rem] font-bold'>
                                                                <strong className='text-[white] text-[.75rem] font-[bolder]'>
                                                                    (<strong onClick={() => setExposureModal(true)}>
                                                                        <span className='text-[red] text-[0.813rem]'>{userInfo ? balance && Math.abs(Number(exposure)).toFixed(2) : ''}</span>
                                                                    </strong>)
                                                                </strong>
                                                            </a>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>)}

                                                <div className='flex text-center text-[white] ml-[10px]'>
                                                    <div className='relative bottom-px right-[2px] text-[white] [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] bg-[linear-gradient(-180deg,#010101_0,_#0e0e0e_100%)] h-[9.33333vw] leading-[5.33333vw] font-bold rounded-[5px] border-[1px] border-[solid] border-[#0b1933] px-[1.86667vw] py-[2.6vw] justify-center items-center flex mr-[6px]'>
                                                        <button type='button' className='text-[white] leading-[5.33333vw] font-bold text-center'
                                                            onClick={() => {
                                                                getBalance()
                                                                setLoadBalance(true)
                                                            }}
                                                        >
                                                            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                <path d="M10 4.029c1.635 0 3.144.36 4.527 1.079 1.365.703 2.443 1.655 3.233 2.854.827 1.247 1.24 2.59 1.24 4.028 0 1.44-.413 2.782-1.24 4.03-.79 1.214-1.868 2.173-3.233 2.877A9.596 9.596 0 0 1 10 20a9.596 9.596 0 0 1-4.527-1.103c-1.365-.704-2.443-1.663-3.233-2.878C1.413 14.772 1 13.43 1 11.99h2.263c0 1.088.301 2.09.903 3.01.602.92 1.42 1.647 2.452 2.182 1.033.536 2.16.804 3.382.804s2.349-.268 3.382-.804c1.033-.535 1.85-1.263 2.452-2.182.602-.92.903-1.922.903-3.01 0-1.087-.301-2.09-.903-3.01-.602-.918-1.42-1.646-2.452-2.181-1.033-.536-2.16-.804-3.382-.804v4.029L4.368 5.012 10 0v4.029z" fill="currentColor"></path>
                                                            </svg>
                                                        </button>
                                                    </div>

                                                    <div className='px-[9px] py-[10px] relative bottom-px left-[2px] bg-[linear-gradient(-180deg,#010101_0,_#0e0e0e_100%)] text-[white] [box-shadow:inset_0_1px_0_0_rgba(255,_255,_255,_.4)] h-[9.33333vw] font-bold rounded-[5px] border-[1px] border-[solid] border-[#0b1933] justify-center items-center flex mr-[6px]' onClick={() => navigate('/setting')}>
                                                        <button type='button' className='text-[white] text-[20px] font-bold'>
                                                            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                <path d="M10.488 13c.621 0 1.203-.16 1.744-.478a3.608 3.608 0 0 0 1.29-1.278A3.32 3.32 0 0 0 14 9.512c0-.621-.16-1.203-.478-1.744a3.578 3.578 0 0 0-1.29-1.29A3.382 3.382 0 0 0 10.488 6a3.32 3.32 0 0 0-1.732.478c-.534.318-.96.748-1.278 1.29A3.382 3.382 0 0 0 7 9.512c0 .621.16 1.198.478 1.732.318.534.744.96 1.278 1.278a3.32 3.32 0 0 0 1.732.478zm7.187-2.014l2.147 1.634c.099.08.157.184.173.313a.555.555 0 0 1-.074.36l-2.073 3.462a.448.448 0 0 1-.26.216.56.56 0 0 1-.357-.024l-2.542-.985c-.658.464-1.242.793-1.752.985l-.37 2.62a.607.607 0 0 1-.185.313.453.453 0 0 1-.309.12H7.927a.485.485 0 0 1-.469-.433l-.395-2.62c-.69-.272-1.267-.6-1.727-.985l-2.567.985c-.263.112-.469.048-.617-.192L.079 13.293a.555.555 0 0 1-.074-.36.464.464 0 0 1 .173-.313l2.171-1.634A7.323 7.323 0 0 1 2.3 10c0-.433.017-.761.05-.986L.177 7.38a.464.464 0 0 1-.173-.313.555.555 0 0 1 .074-.36l2.073-3.462c.148-.24.354-.304.617-.192l2.567.985a8.02 8.02 0 0 1 1.727-.985l.395-2.62A.485.485 0 0 1 7.927 0h4.146c.115 0 .218.04.309.12.09.08.152.184.185.313l.37 2.62c.641.24 1.226.569 1.752.985l2.542-.985a.56.56 0 0 1 .358-.024.448.448 0 0 1 .259.216l2.073 3.462c.066.112.09.232.074.36a.464.464 0 0 1-.173.313l-2.147 1.634c.033.225.05.553.05.986 0 .433-.017.761-.05.986z" fill="currentColor"></path>
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                            }

                        </div>
                    )}
                </div >
            </div >
        </>
    );
}


export default Header;
